// extracted by mini-css-extract-plugin
export default {"button":"Button_button__jKv8p","nonActiveButton":"Button_nonActiveButton__zMcbF","disableButton":"Button_disableButton__6SFBP","diffStyles":"Button_diffStyles__Ccks5"};